import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { project_t } from '../../logic/types';
import moment from 'moment';

export default function ProjectRow({
    project,
    deleteProject,
    duplicateProject,
}: {
    project: project_t;
    deleteProject: (e: React.MouseEvent<HTMLButtonElement>) => void;
    duplicateProject: () => void;
}) {
    return (
        <tr>
            <td>
                <Link to={'/projects/' + project.id}>
                    <span className="black-text link">{project.name}</span>
                </Link>
            </td>
            <td>{moment(project.creationDate).format('DD.MM.YYYY.')}</td>
            <td>
                <a
                    rel="noreferrer"
                    className="flex"
                    href={`${process.env.REACT_APP_API_URL}results/exportResultsForProject?project_id=${project.id}&is_premium=false&version=2`}
                    target="_blank"
                >
                    <i className="material-icons link" title="CSV Preview">
                        get_app
                    </i>
                    Preview
                </a>
        
                <a
                    rel="noreferrer"
                    className="flex"
                    href={`${process.env.REACT_APP_API_URL}results/exportResultsForProject?project_id=${project.id}&is_premium=false&version=1`}
                    target="_blank"
                >
                    <i className="material-icons link" title="CSV Preview">
                        get_app
                    </i>
                    Preview v1
                </a>

                <a
                    rel="noreferrer"
                    className="flex"
                    href={`${process.env.REACT_APP_API_URL}results/exportResultsForProject?project_id=${project.id}&is_premium=false&version=2&csv_download=true`}
                    target="_blank"
                >
                    <i className="material-icons link" title="CSV Preview">
                        get_app
                    </i>
                    Download CSV
                </a>
            </td>
            <td>
                <a
                    rel="noreferrer"
                    className="flex"
                    href={`${process.env.REACT_APP_API_URL}results/exportResultsForProject?project_id=${project.id}&is_premium=true`}
                    target="_blank"
                >
                    <i className="material-icons link" title="CSV Preview">
                        get_app
                    </i>
                    Preview premium
                </a>
            </td>
            <td>
                <Link to={'/projects/' + project.id}>
                    <i className="material-icons link teal-text text-lighten-1" title="Edit">
                        edit
                    </i>
                </Link>
                <i className="material-icons link indigo-text text-lighten-1" onClick={duplicateProject} title="Duplicate">
                    file_copy
                </i>
                <i className="material-icons link red-text text-lighten-1" onClick={deleteProject} title="Delete">
                    delete
                </i>
            </td>
        </tr>
    );
}
